import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { MapConstants } from 'src/app/utils/map.constant';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { environment } from 'src/environments/environment';
import { TIME_IN_MILLIS_CONST } from './seamless-rainfall-map/seamless-rainfall-map-constants';

@Injectable({
  providedIn: 'root'
})
export class SeamlessRainfallDataService {

  constructor(private http: HttpClient, private utilService: UtilsService) { }

  getHeirarchy(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

  getObservedRainfallChartData(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "rf/getObserveChartData";
    return this.http.post<any>(url, postData)
  }

  getNowcastRainfallChartData(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "nowcast/getChartData";
    return this.http.post<any>(url, postData)
  }

  getForecastRainfallChartData(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "weatherForecast/getChartData";
    return this.http.post<any>(url, postData)
  }

  getForecastFileTimeStamp(primarySource, secondarySource) {
    let url = ProjConstants.API_URL + ProjConstants.API_MAPPING['FORECASTFILES'] + '/' + primarySource + "/" + secondarySource;
    let promise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(data => {
        let max = data[primarySource];
        for (let source in data) {
          if (max == undefined || Number(data[source]) > max) {
            max = Number(data[source])
          }
        }
        resolve(max.toString())
      })
    })
    return promise
  }

  getHeatMap(url) {
    let dataPromise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          let obj = this.setMapData(data);
          resolve(obj);
        });
    });
    return dataPromise;
  }

  setMapData(data) {
    let obj = {};
    let imageUrl = {};
    let imageBounds = [];
    for (let block of Object.keys(data)) {
      for (let property of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  getImageBounds(imageBounds) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }

  getHeatMapImageBounds(heatmapimageBounds: any) {
    let latlongs: any = [];
    let imageBounds: any = []

    latlongs.push(heatmapimageBounds['southWest']['latitude']);
    latlongs.push(heatmapimageBounds['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(heatmapimageBounds['northEast']['latitude']);
    latlongs.push(heatmapimageBounds['northEast']['longitude']);
    imageBounds.push(latlongs);
    return imageBounds;
  }

  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  setSeamLessLastThreeDaysData(data, location, queryParams) {
    const finalData = {};
    let tableData = [];
    const tableDataUnsorted = [];

    // Define the desired order of blockLength
    const blockLengthOrder = {
      'hourly': 0,
      '10min': 1,
      '3hr': 2,
      'day': 3
    };

    for (const itemKey of Object.keys(data)) {
      const stateData = data[itemKey];
      const object: any = {};
      const rfValues: any[] = [];
      const timeValues: any[] = [];

      // First sort by timestamp
      const timeSortedData = stateData.table_data.sort((a, b) => a.timeStamp - b.timeStamp);
      timeSortedData.forEach(entry => {
        let value = entry['data']['rf'];
        rfValues.push((value != undefined ) ? parseFloat(value).toFixed(1) : '0');
      })

      // Then sort by blockLength in our desired order
      const sortedData = [...timeSortedData].sort((a, b) => {
        return blockLengthOrder[a.blockLength] - blockLengthOrder[b.blockLength];
      });

      const category = sortedData.length > 0 && sortedData[0].alert ? sortedData[0].alert : '-';

      sortedData.forEach(entry => {
        // rfValues.push((entry.data && entry.data.rf != null) ? entry.data.rf : '-');
        let value = entry['data']['rf'];
        // rfValues.push((value != undefined && value != '-') ? parseFloat(value).toFixed(1) : '0');
        const date = new Date(entry.timeStamp);

        if (entry.blockLength === '10min' || entry.blockLength === 'hourly') {
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          timeValues.push(`${hours}:${minutes}`);
        }
        else if (entry.blockLength === '3hr') {
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          timeValues.push(`${day}/${month}/${year} ${hours}:${minutes}`);
        }
        else if (entry.blockLength === 'day') {
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          timeValues.push(`${day}/${month}/${year}`);
        }
      });

      object['name'] = this.utilService.formatNames(stateData.name);
      object['category'] = category;
      object['rfValues'] = rfValues;
      object['timeValues'] = timeValues;
      object[location] = { val: object['name'] };

      if (stateData.centroid) {
        object['centroid'] = stateData.centroid;
      }
      if (stateData.uuid) {
        object['uuid'] = stateData.uuid;
      }
      tableDataUnsorted.push(object);
    }

    tableData = tableDataUnsorted;
    finalData['data'] = tableData;
    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data), false, location);
    tableColumns.push(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }


  setabgSiteData(data, location, queryParams) {
    const finalData = {};
    let tableData = [];
    const tableDataUnsorted = [];

    // Define the desired order of blockLength
    const blockLengthOrder = {
      'hourly': 0,
      '10min': 1,
      '3hr': 2,
      'day': 3
    };

    for (const itemKey of Object.keys(data)) {
      const stateData = data[itemKey];
      const object: any = {};
      const rfValues: any[] = [];
      const timeValues: any[] = [];

      // First sort by timestamp
      const timeSortedData = stateData.table_data.sort((a, b) => a.timeStamp - b.timeStamp);
      timeSortedData.forEach(entry => {
        let value = entry['data']['rf'];
        rfValues.push((value != undefined ) ? parseFloat(value).toFixed(2) : '0');
      })

      // Then sort by blockLength in our desired order
      const sortedData = [...timeSortedData].sort((a, b) => {
        return blockLengthOrder[a.blockLength] - blockLengthOrder[b.blockLength];
      });

      const category = sortedData.length > 0 && sortedData[0].alert ? sortedData[0].alert : '-';

      sortedData.forEach(entry => {
        // rfValues.push((entry.data && entry.data.rf != null) ? entry.data.rf : '-');
        let value = entry['data']['rf'];
        // rfValues.push((value != undefined && value != '-') ? parseFloat(value).toFixed(1) : '0');
        const date = new Date(entry.timeStamp);

        if (entry.blockLength === '10min' || entry.blockLength === 'hourly') {
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          timeValues.push(`${hours}:${minutes}`);
        }
        else if (entry.blockLength === '3hr') {
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          timeValues.push(`${day}/${month}/${year} ${hours}:${minutes}`);
        }
        else if (entry.blockLength === 'day') {
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          timeValues.push(`${day}/${month}/${year}`);
        }
      });

      object['name'] = this.utilService.formatNames(stateData.name);
      object['category'] = category;
      object['rfValues'] = rfValues;
      object['timeValues'] = timeValues;
      object[location] = { val: object['name'] };

      if (stateData.centroid) {
        object['centroid'] = stateData.centroid;
      }
      if (stateData.uuid) {
        object['uuid'] = stateData.uuid;
      }
      tableDataUnsorted.push(object);
    }

    tableData = tableDataUnsorted;
    finalData['data'] = tableData;
    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data), false, location);
    tableColumns.push(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  getCurrentDateInMilliseconds(): number {
    return new Date().getTime();
  }

  setBlockArray(data) {
    let humidityDataKeys;
    for (let item of Object.keys(data)) {
      humidityDataKeys = [];
      for (let element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          humidityDataKeys.push(element['timeStamp']);
        } else if (element['blockLength'] == 'hourly') {
          humidityDataKeys.push(element['timeStamp']);
        } else if (element['blockLength'] == '10min') {
          humidityDataKeys.push(element['timeStamp']);
        } else if (element['blockLength'] == '3hr') {
          humidityDataKeys.push(element['timeStamp']);
        } else if (element['blockLength'] == 'day') {
          humidityDataKeys.push(element['timeStamp']);
        } else {
          humidityDataKeys.push(element['timeStamp']);
        }
      }
    }
    return this.sortKeys(humidityDataKeys);
  }

  sortKeys(data) {
    let returnArray = [];
    let dummyArray = [];
    for (let timestamp of data) {

      // if (route.snapshot.paramMap.get('time') == '24' && timestamp == '24hr') {
      returnArray.push(timestamp);
      // } else {
      //   dummyArray.push(timestamp);
      // }
    }
    dummyArray = dummyArray.sort();
    for (let ele of dummyArray) {
      returnArray.push(ele);
    }
    return returnArray;
  }

  createColumns(columns, adminSelected, isMandal, location?) {
    let finalColumns = [];
    if (adminSelected) {
      if (isMandal) {
        finalColumns.push({
          val: 'Mandal',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Mandal'
        });
      }
      if (location == 'State') {
        finalColumns.push({
          val: 'State',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'State'
        });
      } else if (location == 'District') {
        finalColumns.push({
          val: 'District',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'District'
        });
      }
      else {
        finalColumns.push({
          val: 'Block',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Block'
        });
      }
    } else {
      if (isMandal) {
        finalColumns.push({
          val: 'Sub Basin',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'SubBasin'
        });
      }
      finalColumns.push({
        val: 'Basin',
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: 'Basin'
      });
    }
    for (const element in columns) {
      finalColumns.push({
        val: columns[element],
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: columns[element]
      });
    }
    return finalColumns;
  }

  buildRainfallChartOptions(formattedChartData: any[], params: any): any {
    if (!formattedChartData || formattedChartData.length === 0) {
      return {};
    }
    const hie: string[] = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    const nextLevel = hie[hie.indexOf(params.locType) + 1] || 'Location';
    const locType = nextLevel.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    const timestampSet = new Set<string>();
    formattedChartData.forEach(item => {
      Object.keys(item).forEach(key => {
        if (key !== "Rainfall Band") {
          timestampSet.add(key);
        }
      });
    });
    const timestamps = Array.from(timestampSet).sort((a, b) => {
      if (a === '24hr') return -1;
      if (b === '24hr') return 1;
      return Number(a) - Number(b);
    });
    const categories = timestamps.map(ts => {
      if (ts === '24hr') {
        return '24hr';
      }
      const date = new Date(Number(ts));
      return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    });
    const colorMap: { [key: string]: string } = {
      "no rainfall": "#ffffff",
      "very light rainfall": "#90ee90",
      "light rainfall": "#32CD32",
      "moderate rainfall": "#ff0000",
      "heavy rainfall": "#0000ff",
      "very heavy rainfall": "#800080",
      "extremely heavy rainfall": "#8b0000"
    };
    const series = formattedChartData.map(item => ({
      name: item["Rainfall Band"],
      type: 'column',
      data: timestamps.map(ts => item[ts] !== undefined ? item[ts] : 0),
      color: colorMap[item["Rainfall Band"]] || "#808080"
    }));
    return {
      chart: {
        type: 'column',
        backgroundColor: '#000000'
      },
      title: {
        text: '',
        style: { color: '#ffffff' }
      },
      xAxis: {
        categories,
        labels: { style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', } },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: `No of ${locType}`,
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',}
        },
        labels: { style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', } },
        gridLineColor: '#808080'
      },
       legend: {

         layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '8px',
    fontWeight: 'normal'
           },
        title: {
          text: '',
          style: { color: '#ffffff', fontWeight: 'bold' }
        }
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: { enabled: true }
        }
      },
      series,
      credits: { enabled: false }
    };
  }

  setObservedChartData(formattedChartData: any[], params: any): any {
    return this.buildRainfallChartOptions(formattedChartData, params);
  }

  getNowcastChartData(formattedChartData: any[], params: any): any {
    return this.buildRainfallChartOptions(formattedChartData, params);
  }

  getForecastChartData(formattedChartData: any[], params: any): any {
    return this.buildRainfallChartOptions(formattedChartData, params);
  }

  setObservedChartDataForLandingPage(formattedChartData: any[]): any {
    return this.observedRainfallChartForLandingPage(formattedChartData);
  }

  // observedRainfallChartForLandingPage(formattedChartData: any[]): any {
  //   if (!formattedChartData || formattedChartData.length === 0) {
  //     return {};
  //   }
  //   const timestampSet = new Set<string>();
  //   formattedChartData.forEach(item => {
  //     Object.keys(item).forEach(key => {
  //       if (key !== "Rainfall Band") {
  //         timestampSet.add(key);
  //       }
  //     });
  //   });
  //   const timestamps = Array.from(timestampSet).sort((a, b) => {
  //     if (a === '24hr') return -1;
  //     if (b === '24hr') return 1;
  //     return Number(a) - Number(b);
  //   });
  //   const categories = timestamps.map(ts => {
  //     if (ts === '24hr') {
  //       return '24hr';
  //     }
  //     const date = new Date(Number(ts));
  //     return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  //   });
  //   const colorMap: { [key: string]: string } = {
  //     "no rainfall": "#ffffff",
  //     "very light rainfall": "#90ee90",
  //     "light rainfall": "#32CD32",
  //     "moderate rainfall": "#ff0000",
  //     "heavy rainfall": "#0000ff",
  //     "very heavy rainfall": "#800080",
  //     "extremely heavy rainfall": "#8b0000"
  //   };
  //   const series = formattedChartData.map(item => ({
  //     name: item["Rainfall Band"],
  //     type: 'column',
  //     data: timestamps.map(ts => item[ts] !== undefined ? item[ts] : 0),
  //     color: colorMap[item["Rainfall Band"]] || "#808080"
  //   }));
  //   return {
  //     chart: {
  //       type: 'column',
  //       height: 280,
  //       backgroundColor: '#404040'
  //     },
  //     title: {
  //       text: '',
  //       style: { color: '#ffffff' }
  //     },
  //     xAxis: {
  //       categories,
  //       labels: { style: { color: '#ffffff' } },
  //       crosshair: true
  //     },
  //     yAxis: {
  //       min: 0,
  //       title: {
  //         text: `No of States`,
  //         style: { color: '#ffffff' }
  //       },
  //       labels: { style: { color: '#ffffff' } },
  //       gridLineColor: '#808080'
  //     },
  //     legend: {
  //       // itemStyle: { color: '#ffffff' }
  //       enabled: false
  //     },
  //     tooltip: {
  //       headerFormat: '<b>{point.x}</b><br/>',
  //       pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
  //     },
  //     plotOptions: {
  //       column: {
  //         stacking: 'normal',
  //         // dataLabels: { enabled: true }
  //       }
  //     },
  //     series,
  //     credits: { enabled: false },
  //     exporting: { enabled: false }
  //   };
  // }


//Stacked Area Chart Implementation
observedRainfallChartForLandingPage(formattedChartData: any[]): any {
  if (!formattedChartData || formattedChartData.length === 0) {
    return {};
  }

  const timestampSet = new Set<string>();
  formattedChartData.forEach(item => {
    Object.keys(item).forEach(key => {
      if (key !== "Rainfall Band") {
        timestampSet.add(key);
      }
    });
  });

  const timestamps = Array.from(timestampSet).sort((a, b) => {
    if (a === '24hr') return -1;
    if (b === '24hr') return 1;
    return Number(a) - Number(b);
  });

  const categories = timestamps.map(ts => {
    if (ts === '24hr') {
      return '24hr';
    }
    const date = new Date(Number(ts));
    return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  });

  const colorMap: { [key: string]: string } = {
    "no rainfall": "#ffffff",
    "very light rainfall": "#90ee90",
    "light rainfall": "#32CD32",
    "moderate rainfall": "#ff0000",
    "heavy rainfall": "#0000ff",
    "very heavy rainfall": "#800080",
    "extremely heavy rainfall": "#8b0000"
  };

  const series = formattedChartData.map(item => ({
    name: item["Rainfall Band"],
    type: 'area',
    data: timestamps.map(ts => item[ts] !== undefined ? item[ts] : 0),
    color: colorMap[item["Rainfall Band"]] || "#808080",
    stacking: 'normal'
  }));

  return {
    chart: {
      type: 'area',
      height: 280,
      backgroundColor: '#404040'
    },
    title: {
      text: '',
      style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
    },
    xAxis: {
      categories,
      labels: { style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', } },
      tickmarkPlacement: 'on'
    },
    yAxis: {
      min: 0,
      title: {
        text: `No of States`,
        style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
      },
      labels: { style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', } },
      gridLineColor: '#808080'
    },
    legend: {
         layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '10px',
    fontWeight: 'normal'
           }
      },
    tooltip: {
      shared: true,
      valueSuffix: ' states'
    },
    plotOptions: {
      area: {
    stacking: 'normal',
    lineColor: '#000000',
    lineWidth: 1,
    fillOpacity: 0.8,
    marker: {
      lineWidth: 1,
      lineColor: '#000000'
    }
  }
    },
    series,
    credits: { enabled: false },
    exporting: { enabled: false }
  };
}

  setChartData(data: any, ProjConstants: any): any[] {
    const formattedChartData = [];
    for (const band of Object.keys(data)) {
      const obj: any = {};
      const bandData = data[band];
      for (const period of Object.keys(bandData)) {
        const entries = bandData[period];
        const timeStamps = Object.keys(entries);
        for (const timestamp of timeStamps) {
          obj[period === '24hr' ? '24hr' : timestamp] = entries[timestamp];
        }
      }
      obj[ProjConstants.CHART_DATA_COLUMNS['RAINFALL']] = band;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }

  getStateBoundaryGEOJSON() {
    const shapeBoundary = new Promise((resolve, reject) => {
      // const boundaryURL = MapConstants.GEOJSON_LAYER_URL + '&typeName=' + layerName + '&cql_filter=' + "uuid='" + cqlfilter + "'"
      const layerName = 'forecast:' + ProjConstants.STATE_TO_LAYERTYPE_NAME['ANDHRA PRADESH_STATE_BOUNDARY'];
      const boundaryURL = MapConstants.GEOJSON_LAYER_URL + '&typeName=' + layerName + '&viewParams=stateName:' + ProjConstants.STATENAME;
      this.http.get(boundaryURL).subscribe(
        jsonGeometry => {
          resolve(jsonGeometry['features'][0]['geometry']);
        },
        err => {
          resolve({})
        });
    });
    return shapeBoundary;
  }

  get(baseUrl: any, endPoint: any, paramsURL?: any) {
    return this.http.get<any>(baseUrl + endPoint + paramsURL);
  }

    convertTimestampToFullBlockValue(ts:any) {
      ts = Number(ts);
      let starthours = new Date(ts).getHours();
      const startminutes = new Date(ts).getMinutes();
      let startAmPm = 'A.M';
      if (starthours == 12) {
        starthours = starthours;
        startAmPm = 'P.M';
      }
      if (starthours > 12) {
        starthours = starthours - 12;
        startAmPm = 'P.M';
      }
      let endhours = new Date(ts + TIME_IN_MILLIS_CONST.MILLIS_IN_1HOUR).getHours();
      const endminutes = new Date(ts + TIME_IN_MILLIS_CONST.MILLIS_IN_1HOUR).getMinutes();
      let endamPm = 'A.M';
      if (endhours == 12) {
        endhours = endhours;
        endamPm = 'P.M';
      }
      if (endhours > 12) {
        endhours = endhours - 12;
        endamPm = 'P.M';
      }
      // return starthours.toString() + ':' + startminutes.toString() + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
      return starthours.toString() + ':' + startminutes.toString() + ' ' + startAmPm //+ ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;

  }

  convertTimestampToTenMinsInterval(ts:any) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startAmPm = 'A.M';
    if (starthours == 12) {
      starthours = starthours;
      startAmPm = 'P.M';
    }
    if (starthours > 12) {
      starthours = starthours - 12;
      startAmPm = 'P.M';
    }
    let endhours = new Date(ts + 10 * 60 * 1000).getHours();
    let endminutes = new Date(ts + 10 * 60 * 1000).getMinutes();
    const endMinutesString = endminutes < 10 ? '0' + endminutes : endminutes.toString();
    let endamPm = 'A.M';
    if (endhours == 12) {
      endhours = endhours;
      endamPm = 'P.M';
    }
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    // return starthours.toString() + ':' + startminutes.toString() + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + endMinutesString.toString() + ' ' + endamPm;
    return starthours.toString() + ':' + (startminutes < 10 ? '0' + startminutes : startminutes.toString()) + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + (endminutes < 10 ? '0' + endminutes : endminutes.toString()) + ' ' + endamPm;
  }

  getDateInFormatForecast(format, refTs) {
    let monthShortLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (refTs == undefined || refTs == null)
      return null;

    let hh, mm;
    let d = new Date(refTs),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear(),
      hour = d.getHours().toString(),
      minute = d.getMinutes().toString(),
      secs = d.getSeconds().toString();
      let amPM = this.convertTimestampToBlockValue(refTs)





    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (hour.length < 2) hour = '0' + hour;
    if (minute.length < 2) minute = '0' + minute;
    if (secs.length < 2) secs = '0' + secs;

    let y = year.toString();

    switch (format) {
      case "YYYY-MM-DD":
        return [year, month, day].join('-');

      case "DD-MM-YYYY":
        return [day, month, year].join('-');

      case "MM-dd-yyyy":
        return [month, day, year].join('-');

      case "dd-MMM-yyyy":
        month = monthShortLabel[d.getMonth()];
        return [day, month, year].join('-');
      case "MMM-yyyy":
        month = monthShortLabel[d.getMonth()];
        return [month, year].join('-');
      case "dd/MM/yyyy":
        return [day, month, year].join('/');
      case "MM/dd/yyyy":
        return [month,day, year].join('/');
      case "yyyyMMdd":
        return [year, month, day].join('');
      case "MMM dd":
        month = monthShortLabel[d.getMonth()];
        return [month, day].join(' ');
      case "MMM":
        month = monthShortLabel[d.getMonth()];
        return [month].join(' ');
      case "dd MMM":
        month = monthShortLabel[d.getMonth()];
        return [day, month].join(' ');
      case 'yyyy-MM-dd':
        return [year, month, day].join('-');
      case "dd/MMM":
        month = monthShortLabel[d.getMonth()];
        return [day, month].join('/');
      case "dd-MMM":
        month = monthShortLabel[d.getMonth()];
        return [day, month].join('-');
      case "yyyyMM":
        return [year, month].join('');
      case "MMyyyy":
        return [month, year].join('-');
      case "yyyy":
        return [year].join('');
      case "yyyy-MM":
        return [year, month].join('-');
      case "DD":
        return [day].join('');
      case "DD-MM-YYYY hh:mm":
        return [day, month, year].join('-') + " " + [hour, minute].join(':');
      case "DD-MM-YYYY hh:mm:ss":
        return [day, month, year].join('-') + " " + [hour, minute,secs].join(':');
      case "DD/MM/YYYY hh:mm":
        return [day, month, year].join('/') + " " + amPM;
      case "DDMMYYYY":
        return [day, month, year].join('');
      case 'hh:mm' :
        return [hour, minute].join(':');
      case 'hh:mm:ss' :
        return [hour, minute,secs].join(':');


      // case "MMM-yy":
      //   month = monthShortLabel[d.getMonth()];
      //   year = y.substr(2,4);
      //   return [month, year].join('-');
    }
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    let hours = new Date(ts).getHours();
    const minutes = new Date(ts).getMinutes();
    let amPm = 'A.M';
    if (hours > 12) {
      hours = hours - 12;
      amPm = 'P.M';
    }
    return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ' ' + amPm;
  }

  convertTimeStampToDay(ts) {
    let timestamp = Number(ts)
    const date = this.getDateInFormatForecast('dd/MM/yyyy', timestamp);
    return date;
  }

  getStartandEndHourTimestamps() {
    const currentDate = new Date();
    const timestamps = {};
    // Set start time to 5:30 AM today
    const startOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 5, 30, 0);
    timestamps['startTs'] = startOfDay.getTime()
    // Calculate the time one hour before the current hour
    const endTime = new Date(currentDate);
    endTime.setHours(currentDate.getHours() - 1, 0, 0, 0); // Set to the start of the previous hour
    timestamps['endTs'] = endTime.getTime()

    return timestamps;
  }

  getDynamicTimestampsInMillis(day) {
    // Current date
    const now = new Date();

    // Calculate the date for three days ago and two days ago
    const thirdLastDay = new Date(now);
    let sDay = day;
    let eDay = day-1;
    thirdLastDay.setDate(now.getDate() - sDay);
    const secondLastDay = new Date(now);
    secondLastDay.setDate(now.getDate() - eDay);

    // Set the time for the start and end timestamps
    const startDate = new Date(thirdLastDay.getFullYear(), thirdLastDay.getMonth(), thirdLastDay.getDate(), 9, 30);  // 9:30 AM
    const endDate = new Date(secondLastDay.getFullYear(), secondLastDay.getMonth(), secondLastDay.getDate(), 7, 30);    // 7:30 AM

    // Convert to milliseconds
    let timeStamp:any = {};
    timeStamp['startTs'] = startDate.getTime();
    timeStamp['endTs'] = endDate.getTime();

    return timeStamp;
  }

  get24HrsTimeStamps(timestamp) {
    let startHour;
    if(timestamp.endsWith('00')) {
      startHour = 8; // Starting hour for the blocks
    } else {
      startHour = 20; // Starting hour for the blocks
    }
    const today = new Date();
    const refTs = today.getTime();

    // Calculate the start timestamp for the blocks
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    let dayStartTs = start.getTime();

    // If the current time is past the start hour, adjust the start time to the next 3-hour block
    if (refTs > dayStartTs) {
      const blockIndex = Math.ceil((refTs - dayStartTs) / 10800000);
      dayStartTs += blockIndex * 10800000;
    }

    const blocks = {};
    let currentBlockIndex = 0;

    // Create blocks for the current day
    while (true) {
      const blockTime = dayStartTs + (currentBlockIndex * 10800000);
      const blockDate = new Date(blockTime);

      // If blockTime is beyond 5:30 AM of the next day, stop creating blocks
      if (blockDate.getDate() > today.getDate() || (blockDate.getHours() === 5 && blockDate.getMinutes() === 30)) {
        break;
      }

      blocks[currentBlockIndex] = {};
      blocks[currentBlockIndex]['timeStamp'] = blockTime;
      blocks[currentBlockIndex]['timeLineName'] = {};
      blocks[currentBlockIndex]['timeLineName']['toolTip'] = this.convert3HoursTimestampToFullBlockValue(blockTime);
      blocks[currentBlockIndex]['timeLineName']['label'] = this.convertTimestampToBlockValue(blockTime);
      blocks[currentBlockIndex]['leftSideName'] = this.convert3HoursTimestampToFullBlockValue(blockTime);
      blocks[currentBlockIndex]['timeLinePos'] = currentBlockIndex;

      currentBlockIndex++;
    }

    // Add additional blocks to cover until 5:30 AM the next day
    const nextDayStart = new Date(today);
    nextDayStart.setDate(today.getDate() + 1);
    nextDayStart.setHours(5, 30, 0, 0);
    const nextDayStartTs = nextDayStart.getTime();

    while (blocks[currentBlockIndex - 1]['timeStamp'] < nextDayStartTs) {
      const blockTime = blocks[currentBlockIndex - 1]['timeStamp'] + 10800000;

      blocks[currentBlockIndex] = {};
      blocks[currentBlockIndex]['timeStamp'] = blockTime;
      blocks[currentBlockIndex]['timeLineName'] = {};
      blocks[currentBlockIndex]['timeLineName']['toolTip'] = this.convert3HoursTimestampToFullBlockValue(blockTime);
      blocks[currentBlockIndex]['timeLineName']['label'] = this.convertTimestampToBlockValue(blockTime);
      blocks[currentBlockIndex]['leftSideName'] = this.convert3HoursTimestampToFullBlockValue(blockTime);
      blocks[currentBlockIndex]['timeLinePos'] = currentBlockIndex;

      currentBlockIndex++;
    }

    // Add the 24hr block at the end
    blocks[currentBlockIndex] = {};
    blocks[currentBlockIndex]['timeStamp'] = blocks[0]['timeStamp'];
    blocks[currentBlockIndex]['timeLineName'] = {};
    blocks[currentBlockIndex]['timeLineName']['toolTip'] = this.convertTimestampToBlockValue(blocks[0]['timeStamp']) + '-' + this.convertTimestampToBlockValue(blocks[0]['timeStamp']);
    blocks[currentBlockIndex]['timeLineName']['label'] = '24hr';
    blocks[currentBlockIndex]['leftSideName'] = '24hr';
    blocks[currentBlockIndex]['timeLinePos'] = currentBlockIndex;

    return blocks;
  }

  get10DaysTimeStamps(day,timestamp) {
    let index = Number(day)
    let hoursIncrement = 0;
    let startHour;
    if(timestamp.endsWith('00')) {
      startHour = 8;
    } else {
      startHour = 20;
    }
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const refTs = tomorrow.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks = {};
    for (let i = 0; i < index; i++) {
      blocks[i] = {};
      blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000) - hoursIncrement;
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['label'] = this.convertTimeStampToDay(blocks[i]['timeStamp'] + hoursIncrement);
      blocks[i]['timeLineName']['toolTip'] = '5:30 AM - 5:30 AM';
      blocks[i]['leftSideName'] = this.convertTimeStampToDay(blocks[i]['timeStamp'] + hoursIncrement);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  getForecastHourlyTimeStamps(day,timestamp){
    let startHour;
    if(timestamp.endsWith('00')) {
      startHour = 8;
    } else {
      startHour = 20;
    }    const todayDate = new Date();
    const nextDate = new Date(todayDate)

    nextDate.setDate(nextDate.getDate() + Number(day))
    const refTs = nextDate.getTime();
    const start = new Date(nextDate);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 10800000);
    const blocks = {};
    for (let i = 0; i < 8; i++) {
      blocks[i] = {};
      // blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 10800000);
      blocks[i]['timeStamp'] = dayStartTs + ((i * 10800000));
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['label'] = this.convertTimestampToBlockValue(blocks[i]['timeStamp']);
      blocks[i]['leftSideName'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks
  }

  convert3HoursTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString() + ':' + startminutes.toString() + ' ' + startamPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
  }
}
